<template>
  <button class="cookie-comply__button" :class="className" @click="handleClick">
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'

interface Props {
  className?: string
}

// Definicja typu dla propsów
const props = defineProps<Props>()

// Definicja emitowanych zdarzeń
const emit = defineEmits<{
  (e: 'handleClick'): void
}>()

// Funkcja obsługująca kliknięcie
const handleClick = () => {
  emit('handleClick')
}
</script>

<style scoped>
.cookie-comply__button {
  padding: 12px 32px;
  border: 1px solid #333;
  background-color: var(--color-white);
  font-weight: 600;
  font-size: 1rem;
  border-radius: 5px;
  cursor: pointer;
}
</style>
